import React, { useState } from 'react';

const FileUpload = ({ onFileUpload }) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            onFileUpload(file);
        }
    };

    return (
        <div>
            <input type="file" accept=".csv, .xlsx" onChange={handleFileChange} />
            {selectedFile && <p>File Selected: {selectedFile.name}</p>}
        </div>
    );
};

export default FileUpload;
